import { useAppContext } from '../contexts/App.context'
import { stringToSnakeCell } from '../functions/onchainMeta'
import { makeChoicesDictionary } from './useCreateBox.functions'
import { CreateBox } from './useCreateBox.types'

export function useCreateBox() {
  const { sender, boxCollection } = useAppContext()

  return {
    sendCreateBoxMessage: async (box: CreateBox, value: bigint) => {
      const {
        name,
        imageUrl,
        choices,
        endTimeInSeconds,
        creatorBasisPoints,
        publishToFeed,
      } = box

      if (!boxCollection) {
        throw new Error('Box collection contract is not initialized.')
      }

      if (!sender) {
        throw new Error('Sender is not initialized.')
      }

      console.log('Отправка сообщения для создания голосования...')

      const result = await boxCollection.send(
        sender,
        { value },

        {
          $$type: 'CreateBoxV0',
          name: stringToSnakeCell(name),
          description: stringToSnakeCell('Box item'),
          image: stringToSnakeCell(imageUrl || DEFAULT_IMAGE),
          choices: makeChoicesDictionary(choices),
          end_time: endTimeInSeconds,
          creator_basis_points: creatorBasisPoints,
          feed_display: publishToFeed,
        },
      )

      console.log('Сообщение успешно отправлено!', result)
    },
  }
}

const DEFAULT_IMAGE = 'https://static.testnet.votebox.io/boxes/default.png'
